export const withProseStyles = {
  baseStyle: {
    ul: {
      listStyle: 'none',
    },
    li: {
      position: 'relative',
    },
    'li::before': {
      content: '"\\2022"',
      position: 'absolute',
      left: '-12px',
    },
    'li > ul': {
      listStyleType: 'none',
      counterReset: 'none',
    },
    ol: {
      listStyle: 'none',
      counterReset: 'custom-counter',
    },
    'ol > li': {
      counterIncrement: 'custom-counter',
    },
    'ol > li::before': {
      content: 'counter(custom-counter) ". "',
      position: 'absolute',
      left: '-12px',
    },
    'ol > li:nth-of-type(n+10)::before': {
      left: '-16px',
    },
  },
};
